import React from "react";
import { Box } from "@mui/material";
import { useChatPopup } from "../../context/ChatPopupContext";
import ChatPopup from "./ChatPopup";

/**
 * ChatPopupManager Component
 * 
 * Renders all open chat popups and manages their positioning.
 * Should be placed at the root level of the app (in App.js or layout).
 */
const ChatPopupManager = () => {
  const {
    openPopups,
    closeChatPopup,
    toggleMinimize,
    toggleMaximize,
    getPopupPosition,
  } = useChatPopup();

  // Keep all popups (including closed ones) to preserve state
  // But only calculate positions for visible ones
  const visiblePopups = openPopups.filter((p) => !p.closed);

  if (openPopups.length === 0) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        right: 0,
        zIndex: 1300,
        pointerEvents: "none",
      }}
    >
      {openPopups.map((popup) => {
        // Calculate position only for visible popups
        const visibleIndex = visiblePopups.findIndex((p) => p.chatId === popup.chatId);
        const position = visibleIndex !== -1 ? getPopupPosition(visibleIndex) : { right: -9999 };
        
        return (
          <Box
            key={popup.chatId}
            sx={{
              pointerEvents: "auto",
              // Hide closed popups off-screen to preserve state
              display: popup.closed ? "none" : "block",
            }}
          >
            <ChatPopup
              popupId={popup.id}
              chatId={popup.chatId}
              entityType={popup.entityType}
              entityData={popup.entityData}
              minimized={popup.minimized}
              maximized={popup.maximized}
              position={position}
              onClose={() => closeChatPopup(popup.id)}
              onToggleMinimize={() => toggleMinimize(popup.id)}
              onToggleMaximize={() => toggleMaximize(popup.id)}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default ChatPopupManager;
